import React, { useEffect, useState } from 'react'
import {
  getRetrieveReportsAAByUserid,
  getAggregtorAccoutById,
  getAADigitapByUserid,
  getAADigitapStatuscheckByUserid,
  handlePeriodicReftchById,
  FetchPrevDatabyId,
  handleSummaryFetchById,
  fetchSummaryReportById
} from '../../../../containers/Admin/AdminActionCreator.component'
import { formatCurrency, formatDateLatest } from '../../../../../utils/commonUtility'
import Nodata from '../../../../../images/nodata.png'
import Pagination from '@mui/material/Pagination';
import Loader from '../../../Loader/Loader.component'
import Popup from '../../../Popup/Popup.component'
import {
  History,
  ArrowDownLeft,
  ArrowUpRight,
  Search,
  Download,
  Calendar,
  X,
  Layers,
  Wallet,
  BarChart3,
  RefreshCw,
  Eye,
  Database,
  FileText,
  Building2,
  CreditCard,
  User,
  Clock,
  ExternalLink,
  CheckCircle,
  AlertCircle
} from 'lucide-react'

export default function AggregatorComponent({ allDetail }) {
  const [loader, setLoader] = useState(false)
  const [DetailsData, setDetailsData] = useState({ parsedData: {}, accountData: {}, holderData: {}, transactions: [] })
  const [currentType, setcurrentType] = useState("")
  const [searchQuery, setSearchQuery] = useState("")
  const [itemsPerPage, setItemsPerPage] = useState(5)
  const [viewDataType, setViewDataType] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [popup, setPopup] = useState({ show: false, popupStatus: "" });
  const [analysisData, setAnalysisData] = useState(null)
  const [showAnalysisModal, setShowAnalysisModal] = useState(false)
  const [prevData, setPrevData] = useState([])
  const [showPrevDataModal, setShowPrevDataModal] = useState(false)
  const [summaryData, setSummaryData] = useState(null)
  const [showSummaryModal, setShowSummaryModal] = useState(false)

  const fetchData = () => {
    setLoader(true);
    // const userId = "fpDudr2aZAeKcCpLUYW64rYRtV1b7aNq";
    const userId = allDetail?.userId || "";
    getAADigitapStatuscheckByUserid(userId, callback => {
      console.log("cal", callback)
      if (callback?.data?.txn_status?.[0]?.code == "ReportGenerated") {
        getRetrieveReportsAAByUserid(userId, "raw", (reportData) => {
          if (reportData?.status === 200 && reportData?.data?.transactions) {
            // Map transactions to match existing structure
            const mappedTxns = reportData.data.transactions.map(t => {
              const amtStr = String(t.amount || "0");
              const isCredit = !amtStr.startsWith("-");
              const cleanAmt = Math.abs(parseFloat(amtStr));
              return {
                valueDate: t.date || t.transaction_timestamp || "",
                narration: t.narration || "",
                type: isCredit ? "CREDIT" : "DEBIT",
                amount: cleanAmt,
                currentBalance: parseFloat(t.balance || "0")
              };
            });

            // Fetch account details next
            getAggregtorAccoutById(userId, (accountData) => {
              setLoader(false);
              if (accountData?.status === 200 && accountData?.data) {
                setDetailsData({
                  transactions: mappedTxns,
                  accountData: {
                    summary: {
                      status: accountData?.data?.accountType ? "ACTIVE" : "INACTIVE",
                      type: accountData?.data?.accountType || "SAVINGS",
                      ifscCode: accountData?.data?.ifscCode || "—",
                      branch: "—",
                      currentBalance: parseFloat(accountData?.data?.current_balance || "0"),
                      micrCode: accountData?.data?.micrCode || "—"
                    }
                  },
                  holderData: {
                    name: accountData?.data?.HolderName || "—",
                    mobile: accountData?.data?.contactNumber || "—",
                    pan: accountData?.data?.pan || "—",
                    address: accountData?.data?.address || "—"
                  },
                  parsedData: {
                    accounts: [
                      {
                        maskedAccNumber: accountData?.data?.accountNumber || "—"
                      }
                    ]
                  }
                });
                setViewDataType(true);
              } else {
                setViewDataType(false);
                setPopup({ show: true, popupStatus: accountData?.message || "Failed to retrieve account details" });
                removePopup();
              }
            });
          } else {
            setLoader(false);
            setViewDataType(false);
            setPopup({ show: true, popupStatus: reportData?.message || "Failed to retrieve aggregator report" });
            removePopup();
          }
        });
      } else {
        setLoader(false);
        setPopup({ show: true, popupStatus: "User Didn't Completed the Consent Journey" });
        removePopup();
      }
    })
  };

  useEffect(() => {
    fetchData()
  }, [])

  // Filtered & Sorted transactions
  const filteredAndSortedTransactions = React.useMemo(() => {
    let txns = DetailsData?.transactions || [];

    // 1. Filter by Category / Type
    if (currentType) {
      txns = txns.filter(t => t.type.toLowerCase() === currentType.toLowerCase());
    }

    // 2. Search query
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      txns = txns.filter(t =>
        String(t.narration).toLowerCase().includes(query) ||
        String(t.valueDate).toLowerCase().includes(query)
      );
    }

    return txns;
  }, [DetailsData?.transactions, currentType, searchQuery]);

  // Paginated list
  const currentPaginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredAndSortedTransactions.slice(startIndex, endIndex);
  }, [filteredAndSortedTransactions, currentPage, itemsPerPage]);

  const handlePagePagination = (e, value) => {
    setCurrentPage(value);
  };

  const closePopup = () => {
    setPopup({ show: false, popupStatus: '' })
  }

  const removePopup = () => {
    setTimeout(() => {
      closePopup()
    }, 5000)
  }

  const handleRegenrate = () => {
    setLoader(true);
    handlePeriodicReftchById(allDetail?.userId, callback => {
      setLoader(false);
      if (callback?.data && callback?.data?.status == "success") {
        fetchData()
      } else {
        setPopup({ show: true, popupStatus: 'The limit has been reached for this month' })
        removePopup()
      }
    })
  }

  const handleAnalysis = () => {
    setLoader(true);
    // const userId = "vHqQ6UkICrDo4Ve4alJNlYCCney6nRmz";
    const userId = allDetail?.userId || "";
    getRetrieveReportsAAByUserid(userId, "analysis", (reportData) => {
      if (reportData?.status === 200) {
        getAADigitapByUserid(userId, (analysisRes) => {
          setLoader(false);
          if (analysisRes?.status === 200 && analysisRes?.data) {
            setAnalysisData(analysisRes.data);
            setShowAnalysisModal(true);
          } else {
            setPopup({ show: true, popupStatus: analysisRes?.message || "Failed to retrieve digitap analysis data" });
            removePopup();
          }
        });
      } else {
        setLoader(false);
        setPopup({ show: true, popupStatus: reportData?.message || "Failed to retrieve aggregator report" });
        removePopup();
      }
    });
  }

  const handlePreviousData = () => {
    setLoader(true);
    const userId = allDetail?.userId || "";
    FetchPrevDatabyId(userId, callback => {
      setLoader(false);
      const rawTxns = callback?.data?.transactions 
        || (Array.isArray(callback?.data) ? callback?.data : [])
        || (callback?.data?.data?.transactions || []);

      if (rawTxns && rawTxns.length > 0) {
        const mappedTxns = rawTxns.map((t, idx) => {
          const amtStr = String(t.amount ?? "0");
          const isCredit = !amtStr.startsWith("-");
          const cleanAmt = Math.abs(parseFloat(amtStr) || 0);
          return {
            id: t.transaction_id || `prev_txn_${idx}`,
            transactionId: t.transaction_id || "—",
            valueDate: t.transaction_timestamp || t.date || "",
            dateOnly: t.date || (t.transaction_timestamp ? String(t.transaction_timestamp).split('T')[0] : ""),
            narration: t.narration || "—",
            type: isCredit ? "CREDIT" : "DEBIT",
            amount: cleanAmt,
            currentBalance: parseFloat(t.balance ?? "0") || 0,
            mode: t.mode_from_source || t.mode || "OTHERS",
            reference: t.reference || "",
            chequeNum: t.cheque_num || ""
          };
        });
        setPrevData(mappedTxns);
        setShowPrevDataModal(true);
      } else {
        setPrevData([]);
        setPopup({ show: true, popupStatus: callback?.message || "No previous transaction data found" });
        removePopup();
      }
    })
  }

  const handleSummary = () => {
    setLoader(true);
    // const userId = "fpDudr2aZAeKcCpLUYW64rYRtV1b7aNq";
    const userId = allDetail?.userId || "";
    if (!userId) {
      setLoader(false);
      setPopup({ show: true, popupStatus: "User ID is required" });
      removePopup();
      return;
    }

    

    handleSummaryFetchById(userId, (fetchRes) => {
      const firstMsg = fetchRes?.data?.msg || fetchRes?.message || "";
      if (firstMsg) {
        setPopup({ show: true, popupStatus: firstMsg });
        removePopup();
      }

      if (fetchRes?.data?.status == "success" || fetchRes?.status == 200) {
        getAADigitapStatuscheckByUserid(userId, (statusRes) => {
          const txnStatus = statusRes?.data?.txn_status || [];
          const isReportGenerated = txnStatus.some(item => item?.code === "ReportGenerated") || txnStatus[0]?.code === "ReportGenerated";

          if (isReportGenerated) {
            fetchSummaryReportById(userId, (summaryRes) => {
              setLoader(false);
              if (summaryRes?.status === 200 && summaryRes?.data) {
                setSummaryData(summaryRes.data);
                setShowSummaryModal(true);
              } else {
                setPopup({ show: true, popupStatus: summaryRes?.message || "Failed to retrieve summary report" });
                removePopup();
              }
            });
          } else {
            setLoader(false);
            const statusMsg = txnStatus[0]?.msg || statusRes?.message || "Report is not generated yet.";
            setPopup({ show: true, popupStatus: statusMsg });
            removePopup();
          }
        });
      } else {
        setLoader(false);
        setPopup({ show: true, popupStatus: firstMsg || "Failed to initiate summary pull request" });
        removePopup();
      }
    });
  };

  const handleViewSummary = () => {
    setLoader(true);
    const userId = allDetail?.userId || "";
    if (!userId) {
      setLoader(false);
      setPopup({ show: true, popupStatus: "User ID is required" });
      removePopup();
      return;
    }

    getAADigitapStatuscheckByUserid(userId, (statusRes) => {
      const txnStatus = statusRes?.data?.txn_status || [];
      const isReportGenerated = txnStatus.some(item => item?.code === "ReportGenerated") || txnStatus[0]?.code === "ReportGenerated";

      if (isReportGenerated) {
        fetchSummaryReportById(userId, (summaryRes) => {
          setLoader(false);
          if (summaryRes?.status === 200 && summaryRes?.data) {
            setSummaryData(summaryRes.data);
            setShowSummaryModal(true);
          } else {
            setPopup({ show: true, popupStatus: summaryRes?.message || "Failed to retrieve summary report" });
            removePopup();
          }
        });
      } else {
        setLoader(false);
        const statusMsg = txnStatus[0]?.msg || statusRes?.message || "Report is not generated yet.";
        setPopup({ show: true, popupStatus: statusMsg });
        removePopup();
      }
    });
  };

  return (
    <>

      {loader ?
        <Loader />
        : ''}

      {
        popup?.show ?
          <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
          : ''}

      <AnalysisModal
        isOpen={showAnalysisModal}
        onClose={() => setShowAnalysisModal(false)}
        data={analysisData}
      />

      <PreviousDataModal
        isOpen={showPrevDataModal}
        onClose={() => setShowPrevDataModal(false)}
        transactions={prevData}
        userId={allDetail?.userId}
      />

      <SummaryModal
        isOpen={showSummaryModal}
        onClose={() => setShowSummaryModal(false)}
        data={summaryData}
      />

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          flexWrap: 'wrap',
          background: '#ffffff',
          padding: '12px 18px',
          borderRadius: '12px',
          border: '1px solid #e2e8f0',
          boxShadow: '0 2px 6px rgba(15, 23, 42, 0.04)',
          margin: '15px 0 20px 0',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '9px',
              background: '#eff6ff',
              color: '#2563eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Database size={18} style={{ width: 'auto', margin: '0' }} />
          </div>
          <div>
            <div style={{ fontSize: '13.5px', fontWeight: '700', color: '#0f172a', lineHeight: '1.2' }}>Statement Controls</div>
            <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>
              Account Aggregator
              {prevData && prevData.length > 0 ? (
                <span style={{ color: '#16a34a', fontWeight: 600, marginLeft: '6px' }}>
                  • {prevData.length} previous records loaded
                </span>
              ) : ''}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={() => handleSummary()}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 14px',
              background: 'linear-gradient(135deg, #0d9488 0%, #059669 100%)',
              color: '#ffffff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '12.5px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(13, 148, 136, 0.25)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 10px rgba(13, 148, 136, 0.35)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 6px rgba(13, 148, 136, 0.25)';
            }}
          >
            <FileText size={15} style={{ width: 'auto', margin: '0' }} />
            <span>Summary</span>
          </button>

          <button
            type="button"
            onClick={() => handleViewSummary()}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 14px',
              background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
              color: '#ffffff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '12.5px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(2, 132, 199, 0.25)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 10px rgba(2, 132, 199, 0.35)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 6px rgba(2, 132, 199, 0.25)';
            }}
          >
            <Eye size={15} style={{ width: 'auto', margin: '0' }} />
            <span>View Summary</span>
          </button>

          <button
            type="button"
            onClick={() => handleAnalysis()}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 14px',
              background: 'linear-gradient(135deg, #1e40af 0%, #2563eb 100%)',
              color: '#ffffff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '12.5px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(37, 99, 235, 0.25)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 10px rgba(37, 99, 235, 0.35)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 6px rgba(37, 99, 235, 0.25)';
            }}
          >
            <BarChart3 size={15} style={{ width: 'auto', margin: '0' }} />
            <span>Analysis</span>
          </button>

          <button
            type="button"
            onClick={() => handleRegenrate()}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 14px',
              background: '#ffffff',
              color: '#334155',
              border: '1px solid #cbd5e1',
              borderRadius: '8px',
              fontSize: '12.5px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f8fafc';
              e.currentTarget.style.borderColor = '#94a3b8';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#ffffff';
              e.currentTarget.style.borderColor = '#cbd5e1';
            }}
          >
            <RefreshCw size={14} style={{ width: 'auto', margin: '0' }} />
            <span>Refetch</span>
          </button>

          <button
            type="button"
            onClick={() => handlePreviousData()}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 14px',
              background: prevData && prevData.length > 0 ? '#f0fdf4' : '#ffffff',
              color: prevData && prevData.length > 0 ? '#15803d' : '#0f766e',
              border: '1px solid',
              borderColor: prevData && prevData.length > 0 ? '#86efac' : '#99f6e4',
              borderRadius: '8px',
              fontSize: '12.5px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 1px 3px rgba(0,0,0,0.03)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = prevData && prevData.length > 0 ? '#dcfce7' : '#f0fdfa';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = prevData && prevData.length > 0 ? '#f0fdf4' : '#ffffff';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <History size={14} style={{ width: 'auto', margin: '0' }} />
            <span>{prevData && prevData.length > 0 ? 'Re-fetch Previous' : 'Fetch Previous Data'}</span>
          </button>

          {prevData && prevData.length > 0 && (
            <button
              type="button"
              onClick={() => setShowPrevDataModal(true)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                background: 'linear-gradient(135deg, #4338ca 0%, #6366f1 100%)',
                color: '#ffffff',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '8px',
                fontSize: '12.5px',
                fontWeight: '700',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
                transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 18px rgba(79, 70, 229, 0.45)';
                e.currentTarget.style.background = 'linear-gradient(135deg, #3730a3 0%, #4f46e5 100%)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(79, 70, 229, 0.3)';
                e.currentTarget.style.background = 'linear-gradient(135deg, #4338ca 0%, #6366f1 100%)';
              }}
            >
              <Eye size={15} style={{ width: 'auto', margin: '0' }} />
              <span>View Previous Data</span>
              <span
                style={{
                  background: 'rgba(255, 255, 255, 0.25)',
                  border: '1px solid rgba(255, 255, 255, 0.4)',
                  color: '#ffffff',
                  padding: '1px 7px',
                  borderRadius: '12px',
                  fontSize: '11px',
                  fontWeight: '800',
                  letterSpacing: '0.2px',
                }}
              >
                {prevData.length}
              </span>
            </button>
          )}
        </div>
      </div>
      {
        viewDataType ?
          <>


            <div style={{ backgroundColor: DetailsData?.accountData?.summary?.status == "ACTIVE" ? '#f0fdf4' : "#fdf0f0", borderRadius: '0.5rem', padding: '15px', border: DetailsData?.accountData?.summary?.status == "ACTIVE" ? '1px solid #bbf7d0' : '1px solid #f7bbbb' }}>
              <h3 style={{ fontWeight: '600', color: '#1f2937', margin: ' 0 0 20px 0', fontSize: '20px' }}>Account Details</h3>
              <div style={{ display: 'grid', gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: '1rem', fontSize: '0.875rem', lineHeight: '1.25rem' }}>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Holder</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.name}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Number</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.parsedData?.accounts?.[0]?.maskedAccNumber}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Type</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.type}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>IFSC Code</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.ifscCode}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Branch</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.branch}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Status</p>
                  <p style={{ color: DetailsData?.accountData?.summary?.status == "ACTIVE" ? '#16a34a' : "#ff4c4c", fontSize: '14px', fontWeight: '500' }}>{DetailsData?.accountData?.summary?.status}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Current Balance</p>
                  <p style={{ color: '#16a34a', fontSize: '14px', fontWeight: '700' }}>{formatCurrency(DetailsData?.accountData?.summary?.currentBalance)}</p>
                </div>

                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>MICR Code</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.micrCode}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Mobile</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.mobile}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>PAN</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.pan}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Address</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.address}</p>
                </div>

              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: '0.5rem', border: '1px solid  #e5e7eb', margin: '20px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#eff6ff', padding: '15px', flexWrap: 'wrap', gap: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                  <h3 style={{ fontWeight: '600', color: '#1f2937', margin: '0', fontSize: '20px' }}>Recent Transactions</h3>
                  {prevData && prevData.length > 0 && (
                    <button
                      type="button"
                      onClick={() => setShowPrevDataModal(true)}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '4px 10px',
                        background: '#ffffff',
                        color: '#4338ca',
                        border: '1px solid #c7d2fe',
                        borderRadius: '6px',
                        fontSize: '11.5px',
                        fontWeight: '700',
                        cursor: 'pointer',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                        transition: 'all 0.15s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#eef2ff';
                        e.currentTarget.style.borderColor = '#818cf8';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#ffffff';
                        e.currentTarget.style.borderColor = '#c7d2fe';
                      }}
                    >
                      <History size={13} style={{ width: 'auto', margin: '0' }} />
                      <span>View Previous Statement ({prevData.length})</span>
                    </button>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                  {/* Page Size Filter */}
                  <select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid #D3D9E9',
                      borderRadius: '5px',
                      width: '60px',
                      fontSize: '13px',
                      outline: 'none'
                    }}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                  </select>
                  {/* Category Filter */}
                  <select
                    value={currentType}
                    onChange={(e) => {
                      setcurrentType(e.target.value);
                      setCurrentPage(1);
                    }}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid #D3D9E9',
                      borderRadius: '5px',
                      width: '130px',
                      fontSize: '13px',
                      outline: 'none'
                    }}
                  >
                    <option value="">Transactions</option>
                    <option value="credit">Credit</option>
                    <option value="debit">Debit</option>
                  </select>
                  {/* Search Bar */}
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setCurrentPage(1);
                    }}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid #D3D9E9',
                      borderRadius: '5px',
                      width: '200px',
                      fontSize: '13px',
                      outline: 'none'
                    }}
                  />
                </div>
              </div>
              {
                currentPaginatedData && currentPaginatedData.length > 0 ?
                  <>
                    <div className='customFinanceTable'>
                      <table>
                        <thead>
                          <tr>
                            <th style={{ textAlign: "left" }}>Date</th>
                            <th style={{ textAlign: "center" }}>Description</th>
                            <th style={{ textAlign: "center" }}>Type</th>
                            <th style={{ textAlign: "right" }}>Amount</th>
                            <th style={{ textAlign: "right" }}>Balance</th>
                          </tr>
                        </thead>
                        <tbody className="custom-divide-y">
                          {currentPaginatedData.map((txn, index) => (
                            <tr key={index}>
                              <td style={{ textAlign: "left" }}>{formatDateLatest(txn?.valueDate)}</td>
                              <td>{txn?.narration || ""}</td>
                              <td>
                                <span
                                  style={{
                                    display: 'inline-flex', padding: '8px', fontWeight: '500', borderRadius: '6px',
                                    background: txn?.type === 'CREDIT' ? "#d1fae5" : "#fee2e2",
                                    color: txn?.type === 'CREDIT' ? "#065f46" : "#991b1b"
                                  }}
                                >
                                  {txn?.type || ""}
                                </span>
                              </td>
                              <td style={{ textAlign: 'right', fontWeight: '500', color: txn?.type == "CREDIT" ? "#16a34a" : "#dc2626" }}>
                                {txn.type === 'CREDIT' ? '+' : '-'}{formatCurrency(txn?.amount)}
                              </td>
                              <td style={{ fontWeight: '500', textAlign: 'right' }}>
                                {formatCurrency(txn?.currentBalance)}
                              </td>
                            </tr>
                          ))
                          }
                        </tbody>
                      </table>
                    </div>
                    <div style={{ margin: '15px', display: 'flex', justifyContent: 'end' }}>
                      <Pagination
                        count={Math.ceil(filteredAndSortedTransactions.length / itemsPerPage)}
                        page={currentPage}
                        onChange={handlePagePagination}
                        variant="outlined"
                        color="primary" shape="rounded"
                      />
                    </div>
                  </>
                  :
                  <div style={{ textAlign: 'center', margin: '20px 0' }}>
                    <img src={Nodata} style={{ width: '40%' }} />
                  </div>}
            </div>

          </>
          :
          <h3 style={{ marginTop: '40px' }} className="text-center"><img src={Nodata} width="300px" /></h3>
      }


    </>
  )
}

const AnalysisModal = ({ isOpen, onClose, data }) => {
  const [activeTab, setActiveTab] = React.useState("summary");
  const [showAllRules, setShowAllRules] = React.useState(false);

  if (!isOpen || !data) return null;

  const { bankLevelSummary = {}, loanAnalysis = [], fraudAnalysis = [] } = data;

  const applicableRules = fraudAnalysis.filter(r => r.result === "applicable");
  const safeRules = fraudAnalysis.filter(r => r.result !== "applicable");

  // Tab Icon SVGs
  const iconSummary = (
    <svg style={{ width: 'auto', marginRight: '6px' }} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" >
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="9" y1="9" x2="15" y2="9" />
      <line x1="9" y1="13" x2="15" y2="13" />
      <line x1="9" y1="17" x2="13" y2="17" />
    </svg>
  );

  const iconLoans = (
    <svg style={{ width: 'auto', marginRight: '6px' }} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );

  const iconAlerts = (
    <svg style={{ width: 'auto', marginRight: '6px' }} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.7)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000,
      padding: '20px',
      animation: 'fadeIn 0.25s ease-out'
    }}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { transform: translateY(24px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .dt-modal-container {
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
          width: 100%;
          max-width: 980px;
          max-height: 85vh;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .dt-modal-header {
          padding: 22px 28px;
          border-bottom: 1px solid #f1f5f9;
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%) !important;
          color: white !important;
        }
        .tab-btn {
          padding: 14px 22px;
          font-weight: 600;
          font-size: 14px;
          border: none;
          background: transparent;
          cursor: pointer;
          color: #64748b;
          border-bottom: 3px solid transparent;
          transition: all 0.2s;
          display: flex;
          align-items: center;
        }
        .tab-btn:hover {
          color: #2563eb;
          background: rgba(37, 99, 235, 0.03);
        }
        .tab-btn.active {
          color: #2563eb;
          border-bottom-color: #2563eb;
        }
        .summary-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 14px;
          padding: 18px;
          display: flex;
          align-items: center;
          gap: 16px;
          transition: all 0.2s ease;
        }
        .summary-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
          border-color: #cbd5e1;
        }
        .rules-scrollbar::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        .rules-scrollbar::-webkit-scrollbar-track {
          background: #f8fafc;
        }
        .rules-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
        .rules-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>

      <div className="dt-modal-container">
        {/* Header */}
        <div className="dt-modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div style={{ textAlign: 'left' }}>
            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', letterSpacing: '-0.3px', color: 'white' }}>Digitap Statement Analysis</h2>
            <p style={{ margin: '4px 0 0 0', opacity: 0.85, fontSize: '13px', color: 'white' }}>Comprehensive risk audit, debt obligations and transaction summary</p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255, 255, 255, 0.15)',
              border: 'none',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              cursor: 'pointer',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.25)'}
            onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.15)'}
          >
            <svg width="auto" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Navigation Tabs */}
        <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', padding: '0 24px' }}>
          <button className={`tab-btn ${activeTab === 'summary' ? 'active' : ''}`} onClick={() => setActiveTab('summary')}>
            {iconSummary} Bank Summary
          </button>
          <button className={`tab-btn ${activeTab === 'loans' ? 'active' : ''}`} onClick={() => setActiveTab('loans')}>
            {iconLoans} Loan Repayments ({loanAnalysis.length})
          </button>
          <button className={`tab-btn ${activeTab === 'fraud' ? 'active' : ''}`} onClick={() => setActiveTab('fraud')}>
            {iconAlerts} Risk Alerts ({applicableRules.length})
          </button>
        </div>

        {/* Content Area */}
        <div className="rules-scrollbar" style={{ padding: '28px', overflowY: 'auto', flex: 1, background: '#f8fafc' }}>

          {/* 1. Summary Tab */}
          {activeTab === 'summary' && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(290px, 1fr))', gap: '20px' }}>

                {/* Avg EOD */}
                <div className="summary-card" style={{ borderLeft: '4px solid #2563eb' }}>
                  <div style={{ background: '#eff6ff', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#2563eb' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h14v4" /><path d="M4 6v12a2 2 0 0 0 2 2h14v-4" /><path d="M18 12a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4v-6z" />
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Avg EOD Balance</div>
                    <div style={{ color: '#1e3a8a', fontSize: '20px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Average EOD Balance"])}
                    </div>
                  </div>
                </div>

                {/* Max Balance */}
                <div className="summary-card" style={{ borderLeft: '4px solid #10b981' }}>
                  <div style={{ background: '#ecfdf5', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" />
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Max Balance</div>
                    <div style={{ color: '#065f46', fontSize: '20px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Max Balance"])}
                    </div>
                  </div>
                </div>

                {/* Median Balance */}
                <div className="summary-card" style={{ borderLeft: '4px solid #f59e0b' }}>
                  <div style={{ background: '#fffbeb', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#f59e0b' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Median EOD Balance</div>
                    <div style={{ color: '#92400e', fontSize: '20px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Median EOD Balance"])}
                    </div>
                  </div>
                </div>

                {/* Total Credits */}
                <div className="summary-card" style={{ borderLeft: '4px solid #3b82f6' }}>
                  <div style={{ background: '#eff6ff', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#3b82f6' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10" /><polyline points="12 8 8 12 12 16" /><line x1="16" y1="12" x2="8" y2="12" />
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total Credits</div>
                    <div style={{ color: '#1d4ed8', fontSize: '18px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Total Amount of Credit Transactions"])}
                    </div>
                    <div style={{ color: '#94a3b8', fontSize: '12px', marginTop: '2px', fontWeight: '500' }}>
                      {bankLevelSummary["Total No. of Credit Transactions"]} Transactions
                    </div>
                  </div>
                </div>

                {/* Total Debits */}
                <div className="summary-card" style={{ borderLeft: '4px solid #ef4444' }}>
                  <div style={{ background: '#fef2f2', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ef4444' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10" /><polyline points="12 16 16 12 12 8" /><line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total Debits</div>
                    <div style={{ color: '#b91c1c', fontSize: '18px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Total Amount of Debit Transactions"])}
                    </div>
                    <div style={{ color: '#94a3b8', fontSize: '12px', marginTop: '2px', fontWeight: '500' }}>
                      {bankLevelSummary["Total No. of Debit Transactions"]} Transactions
                    </div>
                  </div>
                </div>

                {/* EMI Payments */}
                <div className="summary-card" style={{ borderLeft: '4px solid #a855f7' }}>
                  <div style={{ background: '#faf5ff', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a855f7' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" /><circle cx="18" cy="18" r="4" /><path d="M18 16.5V18l1 1" />
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>EMI / Loan Obligations</div>
                    <div style={{ color: '#7e22ce', fontSize: '18px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Total Amount of EMI / loan Payments"] || bankLevelSummary["Total Amount of EMI / loan payments"])}
                    </div>
                    <div style={{ color: '#94a3b8', fontSize: '12px', marginTop: '2px', fontWeight: '500' }}>
                      {bankLevelSummary["No. of EMI / loan payments"]} Payments
                    </div>
                  </div>
                </div>

              </div>
            </div>
          )}

          {/* 2. Loan Analysis Tab */}
          {activeTab === 'loans' && (
            <div>
              {loanAnalysis.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', background: 'white', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                  <svg width="auto" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style={{ marginBottom: '12px' }}>
                    <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                  <p style={{ margin: 0, fontWeight: '600', color: '#475569', fontSize: '15px' }}>No Loan/EMI repayments detected</p>
                  <p style={{ margin: '4px 0 0 0', color: '#94a3b8', fontSize: '13px' }}>The parsing rules did not find any corresponding debit transactions.</p>
                </div>
              ) : (
                <div className='customFinanceTable' style={{ background: 'white', padding: '10px', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                  <table style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left' }}>Date</th>
                        <th style={{ textAlign: 'left' }}>Narration</th>
                        <th style={{ textAlign: 'left' }}>Category</th>
                        <th style={{ textAlign: 'right' }}>Amount</th>
                        <th style={{ textAlign: 'right' }}>Balance</th>
                      </tr>
                    </thead>
                    <tbody className="custom-divide-y">
                      {loanAnalysis.map((loan, idx) => (
                        <tr key={idx}>
                          <td style={{ textAlign: 'left', fontWeight: '500' }}>{loan.date}</td>
                          <td style={{ textAlign: 'left', maxWidth: '340px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {loan.narration}
                          </td>
                          <td style={{ textAlign: 'left' }}>
                            <span style={{
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontSize: '11px',
                              fontWeight: '700',
                              background: '#f3e8ff',
                              color: '#6b21a8',
                              display: 'inline-flex',
                              alignItems: 'center'
                            }}>
                              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#a855f7', marginRight: '6px' }} />
                              {loan.category}
                            </span>
                          </td>
                          <td style={{ textAlign: 'right', fontWeight: '700', color: '#ef4444' }}>
                            {formatCurrency(loan.amount)}
                          </td>
                          <td style={{ textAlign: 'right', color: '#475569', fontWeight: '500' }}>
                            {formatCurrency(loan.balance)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* 3. Fraud / Risk Alerts Tab */}
          {activeTab === 'fraud' && (
            <div>
              {/* Applicable/Risk Rules first */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '24px' }}>
                {applicableRules.map((rule, idx) => (
                  <div key={idx} style={{
                    background: '#ffffff',
                    border: '1px solid #fca5a5',
                    borderRadius: '16px',
                    padding: '20px',
                    boxShadow: '0 4px 6px -1px rgba(220, 38, 38, 0.03)'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #fee2e2', paddingBottom: '12px', marginBottom: '14px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ display: 'flex', alignItems: 'center', color: '#dc2626' }}>
                          <svg width="auto" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
                          </svg>
                        </span>
                        <span style={{ fontWeight: '700', color: '#991b1b', fontSize: '15px' }}>{rule.type}</span>
                      </div>
                      <span style={{
                        background: '#fee2e2',
                        color: '#dc2626',
                        padding: '4px 12px',
                        borderRadius: '20px',
                        fontSize: '11px',
                        fontWeight: '800',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        Triggered Alert
                      </span>
                    </div>

                    {rule.transactions && rule.transactions.length > 0 && (
                      <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '14px', border: '1px solid #e2e8f0' }}>
                        <div style={{ fontWeight: '700', fontSize: '12px', color: '#475569', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <svg width="auto" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" />
                          </svg>
                          Matching Rule Transactions ({rule.transactions.length})
                        </div>
                        <div className="customFinanceTable" style={{ overflowX: 'auto' }}>
                          <table style={{ width: '100%', fontSize: '12px' }}>
                            <thead>
                              <tr>
                                <th style={{ padding: '8px 10px', textAlign: 'left' }}>Date</th>
                                <th style={{ padding: '8px 10px', textAlign: 'left' }}>Narration</th>
                                <th style={{ padding: '8px 10px', textAlign: 'right' }}>Amount</th>
                                <th style={{ padding: '8px 10px', textAlign: 'right' }}>Balance</th>
                              </tr>
                            </thead>
                            <tbody className="custom-divide-y">
                              {rule.transactions.map((t, tIdx) => {
                                const isDebit = String(t.narration).toLowerCase().includes('/dr/') || String(t.category).toLowerCase().includes('transfer to') || t.amount < 0;
                                return (
                                  <tr key={tIdx}>
                                    <td style={{ padding: '8px 10px', fontWeight: '500' }}>{t.transaction_date || t.date}</td>
                                    <td style={{ padding: '8px 10px', maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={t.narration}>
                                      {t.narration}
                                    </td>
                                    <td style={{ padding: '8px 10px', textAlign: 'right', fontWeight: '700', color: isDebit ? '#ef4444' : '#10b981' }}>
                                      {isDebit ? '-' : '+'}{formatCurrency(Math.abs(t.amount))}
                                    </td>
                                    <td style={{ padding: '8px 10px', textAlign: 'right', color: '#64748b', fontWeight: '500' }}>
                                      {formatCurrency(t.balance)}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Safe / Not-triggered Section */}
              <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '20px' }}>
                <button
                  onClick={() => setShowAllRules(!showAllRules)}
                  style={{
                    background: '#ffffff',
                    border: '1px solid #cbd5e1',
                    borderRadius: '8px',
                    color: '#475569',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: '13px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.15s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#f8fafc';
                    e.currentTarget.style.borderColor = '#94a3b8';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = '#ffffff';
                    e.currentTarget.style.borderColor = '#cbd5e1';
                  }}
                >
                  {showAllRules ? (
                    <>
                      <svg style={{ width: 'auto' }} width="auto" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="18 15 12 9 6 15" />
                      </svg>
                      Hide Passed Rules
                    </>
                  ) : (
                    <>
                      <svg style={{ width: 'auto' }} width="auto" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                      Show Passed Rules ({safeRules.length})
                    </>
                  )}
                </button>

                {showAllRules && (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(290px, 1fr))', gap: '12px', marginTop: '16px', animation: 'fadeIn 0.2s ease-out' }}>
                    {safeRules.map((rule, idx) => (
                      <div key={idx} style={{
                        background: '#ffffff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '10px',
                        padding: '12px 14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}>
                        <span style={{ fontSize: '13px', color: '#475569', fontWeight: '500' }}>{rule.type}</span>
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          color: '#10b981',
                          fontWeight: '700',
                          fontSize: '11px',
                          textTransform: 'uppercase',
                          gap: '4px'
                        }}>
                          <svg style={{ width: 'auto' }} width="auto" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                          Passed
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

            </div>
          )}

        </div>

        {/* Footer */}
        <div style={{
          padding: '18px 28px',
          borderTop: '1px solid #f1f5f9',
          display: 'flex',
          justifyContent: 'flex-end',
          background: '#f8fafc'
        }}>
          <button
            className="btn btn-secondary"
            onClick={onClose}
            style={{ padding: '10px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: '600' }}
          >
            Close Report
          </button>
        </div>
      </div>
    </div>
  );
};

const PreviousDataModal = ({ isOpen, onClose, transactions = [], userId = "" }) => {
  const [activeTab, setActiveTab] = React.useState("all"); // "all" | "CREDIT" | "DEBIT"
  const [selectedMode, setSelectedMode] = React.useState("");
  const [searchQuery, setSearchQuery] = React.useState("");
  const [itemsPerPage, setItemsPerPage] = React.useState(10);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [sortBy, setSortBy] = React.useState("date_desc");

  React.useEffect(() => {
    setCurrentPage(1);
  }, [activeTab, selectedMode, searchQuery, itemsPerPage, sortBy]);

  if (!isOpen) return null;

  const uniqueModes = Array.from(
    new Set(transactions.map(t => t.mode).filter(Boolean))
  );

  const creditTxns = transactions.filter(t => t.type === 'CREDIT');
  const debitTxns = transactions.filter(t => t.type === 'DEBIT');
  const totalCreditAmount = creditTxns.reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
  const totalDebitAmount = debitTxns.reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
  const netBalanceChange = totalCreditAmount - totalDebitAmount;

  const validDates = transactions
    .map(t => t.valueDate)
    .filter(Boolean)
    .sort();
  const dateRangeText = validDates.length > 0
    ? `${String(validDates[0]).split('T')[0]} to ${String(validDates[validDates.length - 1]).split('T')[0]}`
    : "—";

  let filtered = transactions.filter(t => {
    if (activeTab !== "all" && t.type !== activeTab) return false;
    if (selectedMode && String(t.mode).toLowerCase() !== selectedMode.toLowerCase()) return false;
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      const matchNarr = String(t.narration || "").toLowerCase().includes(q);
      const matchDate = String(t.valueDate || "").toLowerCase().includes(q);
      const matchId = String(t.transactionId || "").toLowerCase().includes(q);
      const matchMode = String(t.mode || "").toLowerCase().includes(q);
      const matchAmt = String(t.amount || "").includes(q);
      if (!matchNarr && !matchDate && !matchId && !matchMode && !matchAmt) return false;
    }
    return true;
  });

  filtered = [...filtered].sort((a, b) => {
    if (sortBy === "date_desc") {
      return new Date(b.valueDate || 0) - new Date(a.valueDate || 0);
    } else if (sortBy === "date_asc") {
      return new Date(a.valueDate || 0) - new Date(b.valueDate || 0);
    } else if (sortBy === "amt_desc") {
      return (Number(b.amount) || 0) - (Number(a.amount) || 0);
    } else if (sortBy === "amt_asc") {
      return (Number(a.amount) || 0) - (Number(b.amount) || 0);
    }
    return 0;
  });

  const totalFilteredCount = filtered.length;
  const totalPages = Math.ceil(totalFilteredCount / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filtered.slice(startIndex, startIndex + itemsPerPage);

  const handleExportCSV = () => {
    if (!transactions || transactions.length === 0) return;
    const headers = ["Transaction ID", "Date & Time", "Type", "Narration", "Mode", "Amount (INR)", "Balance (INR)", "Reference"];
    const rows = filtered.map(t => [
      `"${t.transactionId}"`,
      `"${t.valueDate}"`,
      `"${t.type}"`,
      `"${String(t.narration || '').replace(/"/g, '""')}"`,
      `"${t.mode}"`,
      t.amount,
      t.currentBalance,
      `"${t.reference}"`
    ]);
    const csvContent = "data:text/csv;charset=utf-8," + [headers.join(","), ...rows.map(r => r.join(","))].join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `previous_transactions_${userId || "user"}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getModeBadgeStyle = (mode) => {
    const m = String(mode || '').toUpperCase();
    if (m === 'UPI') {
      return { bg: '#f3e8ff', color: '#7e22ce', border: '#e9d5ff' };
    }
    if (m === 'IMPS') {
      return { bg: '#e0f2fe', color: '#0369a1', border: '#bae6fd' };
    }
    if (m === 'NEFT') {
      return { bg: '#fef3c7', color: '#b45309', border: '#fde68a' };
    }
    if (m === 'FT') {
      return { bg: '#cffafe', color: '#0e7490', border: '#a5f3fc' };
    }
    return { bg: '#f1f5f9', color: '#475569', border: '#e2e8f0' };
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.7)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000,
      padding: '20px',
      animation: 'fadeIn 0.25s ease-out'
    }}>
      <style>{`
        .prev-modal-container {
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.2);
          width: 100%;
          max-width: 1150px;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .prev-scrollbar::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        .prev-scrollbar::-webkit-scrollbar-track {
          background: #f8fafc;
        }
        .prev-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
        .prev-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>

      <div className="prev-modal-container">
        {/* Modal Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
          padding: '20px 28px',
          color: 'white',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '42px',
              height: '42px',
              borderRadius: '12px',
              background: 'rgba(255, 255, 255, 0.12)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#93c5fd'
            }}>
              <History size={22} style={{ width: 'auto', margin: '0' }} />
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', letterSpacing: '-0.3px', color: 'white' }}>
                  Previous Statement Transactions
                </h2>
                <span style={{
                  fontSize: '11px',
                  fontWeight: 700,
                  background: 'rgba(255, 255, 255, 0.2)',
                  padding: '3px 10px',
                  borderRadius: '20px',
                  color: 'white'
                }}>
                  {transactions.length} Total Records
                </span>
              </div>
              <p style={{ margin: '3px 0 0 0', opacity: 0.85, fontSize: '12.5px', color: '#e2e8f0' }}>
                Historical bank statements retrieved via Cashbridge aggregator
                {userId && <span style={{ opacity: 0.75 }}> · User ID: {userId}</span>}
              </p>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button
              onClick={handleExportCSV}
              style={{
                background: 'rgba(255, 255, 255, 0.15)',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: '8px',
                padding: '7px 14px',
                cursor: 'pointer',
                color: 'white',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '12px',
                fontWeight: '600',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)'}
            >
              <Download size={14} style={{ width: 'auto', margin: '0' }} />
              Export CSV
            </button>
            <button
              onClick={onClose}
              style={{
                background: 'rgba(255, 255, 255, 0.15)',
                border: 'none',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                cursor: 'pointer',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)'}
            >
              <X size={16} style={{ width: 'auto', margin: '0' }} />
            </button>
          </div>
        </div>

        {/* Modal Body */}
        <div className="prev-scrollbar" style={{ padding: '22px 28px', overflowY: 'auto', flex: 1, background: '#f8fafc' }}>
          {/* Summary Metric Cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '14px', marginBottom: '20px' }}>
            <div style={{
              background: '#ffffff',
              border: '1px solid #e2e8f0',
              borderLeft: '4px solid #2563eb',
              borderRadius: '12px',
              padding: '14px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.03)'
            }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: '#eff6ff', color: '#2563eb', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Layers size={18} style={{ width: 'auto', margin: '0' }} />
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' }}>Total Transactions</div>
                <div style={{ fontSize: '18px', fontWeight: '800', color: '#0f172a', marginTop: '2px' }}>{transactions.length}</div>
                <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '1px' }}>{dateRangeText}</div>
              </div>
            </div>

            <div style={{
              background: '#ffffff',
              border: '1px solid #e2e8f0',
              borderLeft: '4px solid #16a34a',
              borderRadius: '12px',
              padding: '14px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.03)'
            }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: '#dcfce7', color: '#16a34a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ArrowDownLeft size={18} style={{ width: 'auto', margin: '0' }} />
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' }}>Total Inflow (Credit)</div>
                <div style={{ fontSize: '18px', fontWeight: '800', color: '#16a34a', marginTop: '2px' }}>
                  +{formatCurrency(totalCreditAmount)}
                </div>
                <div style={{ fontSize: '11px', color: '#15803d', fontWeight: 600, marginTop: '1px' }}>
                  {creditTxns.length} credit entries
                </div>
              </div>
            </div>

            <div style={{
              background: '#ffffff',
              border: '1px solid #e2e8f0',
              borderLeft: '4px solid #dc2626',
              borderRadius: '12px',
              padding: '14px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.03)'
            }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: '#fee2e2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ArrowUpRight size={18} style={{ width: 'auto', margin: '0' }} />
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' }}>Total Outflow (Debit)</div>
                <div style={{ fontSize: '18px', fontWeight: '800', color: '#dc2626', marginTop: '2px' }}>
                  -{formatCurrency(totalDebitAmount)}
                </div>
                <div style={{ fontSize: '11px', color: '#b91c1c', fontWeight: 600, marginTop: '1px' }}>
                  {debitTxns.length} debit entries
                </div>
              </div>
            </div>

            <div style={{
              background: '#ffffff',
              border: '1px solid #e2e8f0',
              borderLeft: '4px solid #8b5cf6',
              borderRadius: '12px',
              padding: '14px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.03)'
            }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: '#ede9fe', color: '#8b5cf6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Wallet size={18} style={{ width: 'auto', margin: '0' }} />
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' }}>Net Cashflow</div>
                <div style={{ fontSize: '18px', fontWeight: '800', color: netBalanceChange >= 0 ? '#16a34a' : '#dc2626', marginTop: '2px' }}>
                  {netBalanceChange >= 0 ? '+' : ''}{formatCurrency(netBalanceChange)}
                </div>
                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '1px' }}>
                  Net variance
                </div>
              </div>
            </div>
          </div>

          {/* Filters and Controls Card */}
          <div style={{
            background: '#ffffff',
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            marginBottom: '16px',
            overflow: 'hidden'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px 18px',
              background: '#f8fafc',
              borderBottom: '1px solid #e2e8f0',
              flexWrap: 'wrap',
              gap: '10px'
            }}>
              {/* Type Tabs */}
              <div style={{ display: 'flex', gap: '6px', background: '#e2e8f0', padding: '3px', borderRadius: '8px' }}>
                <button
                  type="button"
                  onClick={() => setActiveTab('all')}
                  style={{
                    border: 'none',
                    background: activeTab === 'all' ? '#ffffff' : 'transparent',
                    color: activeTab === 'all' ? '#0f172a' : '#64748b',
                    fontWeight: 600,
                    fontSize: '12px',
                    padding: '5px 12px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    boxShadow: activeTab === 'all' ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
                    transition: 'all 0.15s'
                  }}
                >
                  All ({transactions.length})
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab('CREDIT')}
                  style={{
                    border: 'none',
                    background: activeTab === 'CREDIT' ? '#ffffff' : 'transparent',
                    color: activeTab === 'CREDIT' ? '#16a34a' : '#64748b',
                    fontWeight: 600,
                    fontSize: '12px',
                    padding: '5px 12px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    boxShadow: activeTab === 'CREDIT' ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
                    transition: 'all 0.15s'
                  }}
                >
                  Credits ({creditTxns.length})
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab('DEBIT')}
                  style={{
                    border: 'none',
                    background: activeTab === 'DEBIT' ? '#ffffff' : 'transparent',
                    color: activeTab === 'DEBIT' ? '#dc2626' : '#64748b',
                    fontWeight: 600,
                    fontSize: '12px',
                    padding: '5px 12px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    boxShadow: activeTab === 'DEBIT' ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
                    transition: 'all 0.15s'
                  }}
                >
                  Debits ({debitTxns.length})
                </button>
              </div>

              {/* Filters toolbar */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                {/* Mode dropdown */}
                {uniqueModes.length > 0 && (
                  <select
                    value={selectedMode}
                    onChange={(e) => setSelectedMode(e.target.value)}
                    style={{
                      padding: '7px 10px',
                      border: '1px solid #cbd5e1',
                      borderRadius: '7px',
                      fontSize: '12px',
                      outline: 'none',
                      background: '#ffffff',
                      color: '#334155'
                    }}
                  >
                    <option value="">All Modes</option>
                    {uniqueModes.map((m, idx) => (
                      <option key={idx} value={m}>{m}</option>
                    ))}
                  </select>
                )}

                {/* Sort dropdown */}
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  style={{
                    padding: '7px 10px',
                    border: '1px solid #cbd5e1',
                    borderRadius: '7px',
                    fontSize: '12px',
                    outline: 'none',
                    background: '#ffffff',
                    color: '#334155'
                  }}
                >
                  <option value="date_desc">Latest First</option>
                  <option value="date_asc">Oldest First</option>
                  <option value="amt_desc">Highest Amount</option>
                  <option value="amt_asc">Lowest Amount</option>
                </select>

                {/* Page Size */}
                <select
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  style={{
                    padding: '7px 10px',
                    border: '1px solid #cbd5e1',
                    borderRadius: '7px',
                    fontSize: '12px',
                    outline: 'none',
                    background: '#ffffff',
                    color: '#334155'
                  }}
                >
                  <option value={10}>10 / page</option>
                  <option value={20}>20 / page</option>
                  <option value={50}>50 / page</option>
                  <option value={100}>100 / page</option>
                </select>

                {/* Search */}
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    placeholder="Search description, mode, amount..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                      padding: '7px 12px 7px 30px',
                      border: '1px solid #cbd5e1',
                      borderRadius: '7px',
                      fontSize: '12px',
                      outline: 'none',
                      width: '230px',
                      background: '#ffffff'
                    }}
                  />
                  <div style={{ position: 'absolute', left: '10px', top: '8px', color: '#94a3b8', pointerEvents: 'none' }}>
                    <Search size={14} style={{ width: 'auto', margin: '0' }} />
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            {paginatedData && paginatedData.length > 0 ? (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12.5px' }}>
                  <thead>
                    <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0', color: '#475569' }}>
                      <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, width: '45px' }}>#</th>
                      <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, width: '155px' }}>Date & Time</th>
                      <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600 }}>Description</th>
                      <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, width: '90px' }}>Mode</th>
                      <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, width: '85px' }}>Type</th>
                      <th style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 600, width: '130px' }}>Amount</th>
                      <th style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 600, width: '130px' }}>Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((txn, index) => {
                      const modeStyle = getModeBadgeStyle(txn.mode);
                      const isCredit = txn.type === 'CREDIT';
                      const globalIdx = startIndex + index + 1;
                      return (
                        <tr
                          key={txn.id || index}
                          style={{
                            borderBottom: '1px solid #f1f5f9',
                            background: index % 2 === 0 ? '#ffffff' : '#fafafa',
                            transition: 'background 0.15s'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                          onMouseLeave={(e) => e.currentTarget.style.background = index % 2 === 0 ? '#ffffff' : '#fafafa'}
                        >
                          <td style={{ padding: '10px 14px', color: '#94a3b8', fontSize: '11px', fontWeight: 600 }}>
                            {globalIdx}
                          </td>
                          <td style={{ padding: '10px 14px', color: '#1e293b', whiteSpace: 'nowrap' }}>
                            <div style={{ fontWeight: 600 }}>{txn.dateOnly || (txn.valueDate && txn.valueDate.split('T')[0])}</div>
                            {txn.valueDate && txn.valueDate.includes('T') && (
                              <div style={{ fontSize: '11px', color: '#64748b', marginTop: '1px' }}>
                                {txn.valueDate.split('T')[1].split('+')[0]}
                              </div>
                            )}
                          </td>
                          <td style={{ padding: '10px 14px', color: '#334155' }}>
                            <div style={{ fontWeight: 500, wordBreak: 'break-word', lineHeight: '1.4' }}>
                              {txn.narration || "—"}
                            </div>
                            {txn.transactionId && txn.transactionId !== "—" && (
                              <div style={{ fontSize: '10.5px', color: '#94a3b8', marginTop: '2px' }}>
                                Txn ID: {txn.transactionId}
                              </div>
                            )}
                          </td>
                          <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                            <span style={{
                              display: 'inline-block',
                              padding: '2px 8px',
                              borderRadius: '6px',
                              fontSize: '11px',
                              fontWeight: 700,
                              background: modeStyle.bg,
                              color: modeStyle.color,
                              border: `1px solid ${modeStyle.border}`
                            }}>
                              {txn.mode || "OTHERS"}
                            </span>
                          </td>
                          <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                            <span style={{
                              display: 'inline-block',
                              padding: '3px 8px',
                              borderRadius: '6px',
                              fontSize: '10.5px',
                              fontWeight: 700,
                              background: isCredit ? '#dcfce7' : '#fee2e2',
                              color: isCredit ? '#15803d' : '#b91c1c'
                            }}>
                              {isCredit ? 'CREDIT' : 'DEBIT'}
                            </span>
                          </td>
                          <td style={{
                            padding: '10px 14px',
                            textAlign: 'right',
                            fontWeight: 700,
                            color: isCredit ? '#16a34a' : '#dc2626',
                            whiteSpace: 'nowrap'
                          }}>
                            {isCredit ? '+' : '-'}{formatCurrency(txn.amount)}
                          </td>
                          <td style={{
                            padding: '10px 14px',
                            textAlign: 'right',
                            fontWeight: 600,
                            color: '#0f172a',
                            whiteSpace: 'nowrap'
                          }}>
                            {formatCurrency(txn.currentBalance)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                <img src={Nodata} alt="No data" style={{ width: '180px', marginBottom: '12px' }} />
                <div style={{ fontSize: '14px', fontWeight: 600, color: '#64748b' }}>No transactions found</div>
                <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '4px' }}>Try adjusting your filters or search keywords</div>
              </div>
            )}

            {/* Pagination Footer */}
            {filtered.length > 0 && (
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 18px',
                background: '#f8fafc',
                borderTop: '1px solid #e2e8f0',
                flexWrap: 'wrap',
                gap: '10px'
              }}>
                <div style={{ fontSize: '12px', color: '#64748b' }}>
                  Showing <span style={{ fontWeight: 600, color: '#0f172a' }}>{startIndex + 1}</span> to{' '}
                  <span style={{ fontWeight: 600, color: '#0f172a' }}>{Math.min(startIndex + itemsPerPage, filtered.length)}</span> of{' '}
                  <span style={{ fontWeight: 600, color: '#0f172a' }}>{filtered.length}</span> entries
                  {filtered.length !== transactions.length && ` (filtered from ${transactions.length} total)`}
                </div>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={(e, val) => setCurrentPage(val)}
                  variant="outlined"
                  color="primary"
                  shape="rounded"
                  size="small"
                />
              </div>
            )}
          </div>
        </div>

        {/* Modal Footer */}
        <div style={{
          padding: '14px 28px',
          borderTop: '1px solid #f1f5f9',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: '#ffffff'
        }}>
          <div style={{ fontSize: '12px', color: '#64748b' }}>
            Historical transactions retrieved from Cashbridge
          </div>
          <button
            className="btn btn-secondary"
            onClick={onClose}
            style={{ padding: '8px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: '600' }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const SummaryModal = ({ isOpen, onClose, data }) => {
  const [selectedBankIndex, setSelectedBankIndex] = React.useState(0);

  if (!isOpen || !data) return null;

  const banks = Array.isArray(data?.banks) ? data.banks : [];
  const totalAccounts = banks.reduce((sum, b) => sum + (b?.accounts?.length || 0), 0);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.7)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000,
      padding: '20px',
      animation: 'fadeIn 0.25s ease-out'
    }}>
      <style>{`
        .summary-modal-container {
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.2);
          width: 100%;
          max-width: 1100px;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .summary-scrollbar::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        .summary-scrollbar::-webkit-scrollbar-track {
          background: #f8fafc;
        }
        .summary-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
        .summary-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
        .meta-stat-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 14px 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
          transition: all 0.2s ease;
        }
        .meta-stat-card:hover {
          border-color: #cbd5e1;
          transform: translateY(-1px);
        }
      `}</style>

      <div className="summary-modal-container">
        {/* Modal Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          background: 'linear-gradient(135deg, #042f2e 0%, #0d9488 50%, #059669 100%)',
          padding: '20px 28px',
          color: 'white',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '42px',
              height: '42px',
              borderRadius: '12px',
              background: 'rgba(255, 255, 255, 0.15)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#99f6e4'
            }}>
              <FileText size={22} style={{ width: 'auto', margin: '0' }} />
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', letterSpacing: '-0.3px', color: 'white' }}>
                  Account Aggregator Summary Report
                </h2>
                <span style={{
                  fontSize: '11px',
                  fontWeight: 700,
                  background: 'rgba(255, 255, 255, 0.2)',
                  padding: '3px 10px',
                  borderRadius: '20px',
                  color: 'white'
                }}>
                  v{data?.dg_report_version || "2.0"} (Report #{data?.report_num || 1})
                </span>
              </div>
              <p style={{ margin: '3px 0 0 0', opacity: 0.9, fontSize: '12.5px', color: '#ccfbf1' }}>
                Summary statements and bank account profile aggregation
                {data?.client_ref_num && <span style={{ opacity: 0.8 }}> · Ref: {data.client_ref_num}</span>}
              </p>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {data?.source_report && (
              <a
                href={data.source_report}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'rgba(255, 255, 255, 0.15)',
                  border: '1px solid rgba(255, 255, 255, 0.25)',
                  borderRadius: '8px',
                  padding: '7px 14px',
                  cursor: 'pointer',
                  color: 'white',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '12px',
                  fontWeight: '600',
                  textDecoration: 'none',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)'}
              >
                <ExternalLink size={14} style={{ width: 'auto', margin: '0' }} />
                Source JSON
              </a>
            )}
            <button
              onClick={onClose}
              style={{
                background: 'rgba(255, 255, 255, 0.15)',
                border: 'none',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                cursor: 'pointer',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)'}
            >
              <X size={16} style={{ width: 'auto', margin: '0' }} />
            </button>
          </div>
        </div>

        {/* Modal Body */}
        <div className="summary-scrollbar" style={{ padding: '24px 28px', overflowY: 'auto', flex: 1, background: '#f8fafc' }}>
          
          {/* Section 1: Overview Metadata Grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '14px', marginBottom: '24px' }}>
            
            {/* Date Range Card */}
            <div className="meta-stat-card" style={{ borderLeft: '4px solid #0d9488' }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: '#ccfbf1', color: '#0f766e', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Calendar size={18} style={{ width: 'auto', margin: '0' }} />
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Date Range</div>
                <div style={{ fontSize: '14px', fontWeight: '800', color: '#0f172a', marginTop: '2px' }}>
                  {data?.start_date || "—"} to {data?.end_date || "—"}
                </div>
                <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '1px' }}>
                  Statement Span
                </div>
              </div>
            </div>

            {/* Duration Card */}
            <div className="meta-stat-card" style={{ borderLeft: '4px solid #2563eb' }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: '#eff6ff', color: '#2563eb', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Clock size={18} style={{ width: 'auto', margin: '0' }} />
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Duration & Version</div>
                <div style={{ fontSize: '15px', fontWeight: '800', color: '#1e3a8a', marginTop: '2px' }}>
                  {data?.duration_in_month ?? 0} Month(s)
                </div>
                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '1px' }}>
                  v{data?.dg_report_version || "2.0"} · Report #{data?.report_num || 1}
                </div>
              </div>
            </div>

            {/* Report Fetch Info */}
            <div className="meta-stat-card" style={{ borderLeft: '4px solid #8b5cf6' }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: '#f5f3ff', color: '#8b5cf6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <RefreshCw size={18} style={{ width: 'auto', margin: '0' }} />
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Fetch Details</div>
                <div style={{ fontSize: '13px', fontWeight: '700', color: '#5b21b6', marginTop: '2px', wordBreak: 'break-all' }}>
                  {data?.report_fetch_type || "PERIODIC"}
                </div>
                <div style={{ fontSize: '10.5px', color: '#94a3b8', marginTop: '1px' }}>
                  {data?.report_fetch_time || "—"}
                </div>
              </div>
            </div>

            {/* Source of Data */}
            <div className="meta-stat-card" style={{ borderLeft: '4px solid #f59e0b' }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: '#fffbeb', color: '#d97706', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Database size={18} style={{ width: 'auto', margin: '0' }} />
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Source & Institutions</div>
                <div style={{ fontSize: '14px', fontWeight: '800', color: '#92400e', marginTop: '2px', textTransform: 'capitalize' }}>
                  {data?.source_of_data || "accountaggregator"}
                </div>
                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '1px' }}>
                  {banks.length} Bank(s) · {totalAccounts} Account(s)
                </div>
              </div>
            </div>

          </div>

          {/* Section 2: Banks and Accounts Details */}
          <div style={{ marginBottom: '16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', flexWrap: 'wrap', gap: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Building2 size={18} style={{ color: '#0f766e' }} />
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#0f172a' }}>
                  Aggregated Bank Accounts ({banks.length})
                </h3>
              </div>

              {/* Bank selector tabs if multiple banks */}
              {banks.length > 1 && (
                <div style={{ display: 'flex', gap: '6px', background: '#e2e8f0', padding: '3px', borderRadius: '8px' }}>
                  {banks.map((b, idx) => (
                    <button
                      key={idx}
                      type="button"
                      onClick={() => setSelectedBankIndex(idx)}
                      style={{
                        border: 'none',
                        background: selectedBankIndex === idx ? '#ffffff' : 'transparent',
                        color: selectedBankIndex === idx ? '#0f766e' : '#64748b',
                        fontWeight: 600,
                        fontSize: '12px',
                        padding: '4px 12px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        boxShadow: selectedBankIndex === idx ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
                        transition: 'all 0.15s'
                      }}
                    >
                      {b.bank || `Bank ${idx + 1}`} ({b?.accounts?.length || 0})
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* List of Banks */}
            {banks.length === 0 ? (
              <div style={{ padding: '40px 20px', textAlign: 'center', background: '#ffffff', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <img src={Nodata} alt="No Bank Data" style={{ width: '160px', marginBottom: '10px' }} />
                <div style={{ fontSize: '14px', fontWeight: 600, color: '#64748b' }}>No bank accounts aggregated</div>
              </div>
            ) : (
              banks.map((bankItem, bIdx) => {
                // If multiple banks exist and tab filtering is desired, or show all
                if (banks.length > 1 && selectedBankIndex !== bIdx) return null;

                const accounts = Array.isArray(bankItem?.accounts) ? bankItem.accounts : [];

                return (
                  <div
                    key={bIdx}
                    style={{
                      background: '#ffffff',
                      borderRadius: '16px',
                      border: '1px solid #e2e8f0',
                      boxShadow: '0 2px 8px rgba(15, 23, 42, 0.04)',
                      marginBottom: '20px',
                      overflow: 'hidden'
                    }}
                  >
                    {/* Bank Header */}
                    <div style={{
                      padding: '16px 20px',
                      background: 'linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%)',
                      borderBottom: '1px solid #99f6e4',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: '10px'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '8px',
                          background: '#0d9488',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <Building2 size={18} style={{ width: 'auto', margin: '0' }} />
                        </div>
                        <div>
                          <div style={{ fontSize: '16px', fontWeight: '800', color: '#0f766e' }}>
                            {bankItem?.bank || "Unknown Bank"}
                          </div>
                          <div style={{ fontSize: '11.5px', color: '#115e59', marginTop: '1px' }}>
                            Source ID: <span style={{ fontWeight: 600 }}>{bankItem?.source_bank_id || "—"}</span>
                            {bankItem?.digitap_institution_id && (
                              <span> · Institution ID: <span style={{ fontWeight: 600 }}>{bankItem.digitap_institution_id}</span></span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{
                          background: '#ffffff',
                          border: '1px solid #99f6e4',
                          color: '#0f766e',
                          padding: '3px 10px',
                          borderRadius: '16px',
                          fontSize: '11.5px',
                          fontWeight: '700'
                        }}>
                          {accounts.length} {accounts.length === 1 ? 'Account' : 'Accounts'}
                        </span>
                        {bankItem?.multiple_accounts_found && (
                          <span style={{
                            background: bankItem.multiple_accounts_found === 'yes' ? '#eff6ff' : '#f8fafc',
                            border: '1px solid #cbd5e1',
                            color: '#475569',
                            padding: '3px 10px',
                            borderRadius: '16px',
                            fontSize: '11px',
                            fontWeight: '600'
                          }}>
                            Multiple: {bankItem.multiple_accounts_found}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Bank Accounts Body */}
                    <div style={{ padding: '20px' }}>
                      {accounts.map((acc, aIdx) => {
                        const holders = acc?.customer_info?.holders || [];
                        const isActive = String(acc?.account_status || '').toUpperCase() === 'ACTIVE';

                        return (
                          <div
                            key={aIdx}
                            style={{
                              background: '#f8fafc',
                              border: '1px solid #e2e8f0',
                              borderRadius: '12px',
                              padding: '18px',
                              marginBottom: aIdx === accounts.length - 1 ? '0' : '16px'
                            }}
                          >
                            {/* Account Top Title Bar */}
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              borderBottom: '1px solid #e2e8f0',
                              paddingBottom: '12px',
                              marginBottom: '14px',
                              flexWrap: 'wrap',
                              gap: '10px'
                            }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <CreditCard size={18} style={{ color: '#0d9488' }} />
                                <span style={{ fontSize: '15px', fontWeight: '800', color: '#0f172a' }}>
                                  {acc?.account_number || "—"}
                                </span>
                                <span style={{
                                  background: '#e0f2fe',
                                  color: '#0369a1',
                                  padding: '2px 8px',
                                  borderRadius: '6px',
                                  fontSize: '11px',
                                  fontWeight: '700'
                                }}>
                                  {acc?.account_type || "SAVINGS"}
                                </span>
                                {acc?.facility && (
                                  <span style={{
                                    background: '#ede9fe',
                                    color: '#6d28d9',
                                    padding: '2px 8px',
                                    borderRadius: '6px',
                                    fontSize: '11px',
                                    fontWeight: '700'
                                  }}>
                                    {acc.facility}
                                  </span>
                                )}
                              </div>

                              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <span style={{
                                  background: isActive ? '#dcfce7' : '#fee2e2',
                                  color: isActive ? '#15803d' : '#b91c1c',
                                  padding: '3px 10px',
                                  borderRadius: '20px',
                                  fontSize: '11px',
                                  fontWeight: '800',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.4px',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '4px'
                                }}>
                                  {isActive ? (
                                    <CheckCircle size={12} style={{ width: 'auto', margin: '0' }} />
                                  ) : (
                                    <AlertCircle size={12} style={{ width: 'auto', margin: '0' }} />
                                  )}
                                  {acc?.account_status || "ACTIVE"}
                                </span>
                              </div>
                            </div>

                            {/* Financial Details Grid */}
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                              gap: '12px',
                              marginBottom: '16px',
                              background: '#ffffff',
                              padding: '14px',
                              borderRadius: '10px',
                              border: '1px solid #e2e8f0'
                            }}>
                              <div>
                                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600' }}>Current Balance</div>
                                <div style={{ fontSize: '17px', fontWeight: '800', color: '#16a34a', marginTop: '2px' }}>
                                  {formatCurrency(acc?.current_balance)}
                                </div>
                                {acc?.balance_date_time && (
                                  <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '1px' }}>
                                    As of {acc.balance_date_time.replace('T', ' ')}
                                  </div>
                                )}
                              </div>

                              <div>
                                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600' }}>IFSC & Branch</div>
                                <div style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginTop: '2px' }}>
                                  {acc?.ifsc_code || "—"}
                                </div>
                                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '1px' }}>
                                  {acc?.location || "—"}
                                </div>
                              </div>

                              <div>
                                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600' }}>MICR Code</div>
                                <div style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginTop: '2px' }}>
                                  {acc?.micr_code || "—"}
                                </div>
                                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '1px' }}>
                                  Currency: {acc?.currency || "INR"}
                                </div>
                              </div>

                              <div>
                                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600' }}>Opening Date</div>
                                <div style={{ fontSize: '13px', fontWeight: '700', color: '#1e293b', marginTop: '2px' }}>
                                  {acc?.opening_date || "—"}
                                </div>
                                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '1px' }}>
                                  OD Limit: {acc?.current_od_Limit ? formatCurrency(acc.current_od_Limit) : '₹0'}
                                </div>
                              </div>
                            </div>

                            {/* Customer / Holder Information Section */}
                            <div style={{
                              background: '#ffffff',
                              borderRadius: '10px',
                              padding: '14px',
                              border: '1px solid #e2e8f0'
                            }}>
                              <div style={{
                                fontSize: '12px',
                                fontWeight: '700',
                                color: '#0f766e',
                                marginBottom: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                              }}>
                                <User size={14} style={{ width: 'auto', margin: '0' }} />
                                <span>Account Holder & KYC Details</span>
                                {acc?.customer_info?.holding_type && (
                                  <span style={{
                                    fontSize: '10.5px',
                                    color: '#64748b',
                                    fontWeight: '600',
                                    marginLeft: '6px'
                                  }}>
                                    (Holding: {acc.customer_info.holding_type})
                                  </span>
                                )}
                              </div>

                              {holders.length > 0 ? (
                                holders.map((h, hIdx) => (
                                  <div
                                    key={hIdx}
                                    style={{
                                      display: 'grid',
                                      gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                                      gap: '10px',
                                      fontSize: '12px',
                                      padding: hIdx > 0 ? '10px 0 0 0' : '0',
                                      borderTop: hIdx > 0 ? '1px dashed #e2e8f0' : 'none'
                                    }}
                                  >
                                    <div>
                                      <span style={{ color: '#64748b' }}>Holder Name: </span>
                                      <span style={{ fontWeight: '700', color: '#0f172a' }}>{h?.name || "—"}</span>
                                    </div>
                                    <div>
                                      <span style={{ color: '#64748b' }}>Contact: </span>
                                      <span style={{ fontWeight: '600', color: '#0f172a' }}>{h?.contact_number || "—"}</span>
                                    </div>
                                    <div>
                                      <span style={{ color: '#64748b' }}>Email: </span>
                                      <span style={{ fontWeight: '600', color: '#0f172a' }}>{h?.email || "—"}</span>
                                    </div>
                                    <div>
                                      <span style={{ color: '#64748b' }}>PAN: </span>
                                      <span style={{ fontWeight: '700', color: '#0f172a' }}>{h?.pan || "—"}</span>
                                    </div>
                                    <div>
                                      <span style={{ color: '#64748b' }}>DOB: </span>
                                      <span style={{ fontWeight: '600', color: '#0f172a' }}>{h?.dob || "—"}</span>
                                    </div>
                                    <div>
                                      <span style={{ color: '#64748b' }}>CKYC: </span>
                                      <span style={{ fontWeight: '600', color: '#0f172a' }}>{h?.ckyc_compliance || "—"}</span>
                                    </div>
                                    {h?.nominee && (
                                      <div>
                                        <span style={{ color: '#64748b' }}>Nominee: </span>
                                        <span style={{ fontWeight: '600', color: '#0f172a' }}>{h.nominee}</span>
                                      </div>
                                    )}
                                    {h?.address && (
                                      <div style={{ gridColumn: '1 / -1' }}>
                                        <span style={{ color: '#64748b' }}>Address: </span>
                                        <span style={{ fontWeight: '500', color: '#334155' }}>{h.address}</span>
                                      </div>
                                    )}
                                  </div>
                                ))
                              ) : (
                                <div style={{ fontSize: '12px', color: '#94a3b8' }}>No holder details provided</div>
                              )}
                            </div>

                            {/* Transactions Table if present in account */}
                            {Array.isArray(acc?.transactions) && acc.transactions.length > 0 && (
                              <div style={{ marginTop: '14px', background: '#ffffff', borderRadius: '10px', padding: '12px', border: '1px solid #e2e8f0' }}>
                                <div style={{ fontSize: '12px', fontWeight: '700', color: '#0f172a', marginBottom: '8px' }}>
                                  Embedded Transactions ({acc.transactions.length})
                                </div>
                                <div className="customFinanceTable" style={{ overflowX: 'auto' }}>
                                  <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                      <tr>
                                        <th style={{ textAlign: 'left' }}>Date</th>
                                        <th style={{ textAlign: 'left' }}>Description</th>
                                        <th style={{ textAlign: 'center' }}>Type</th>
                                        <th style={{ textAlign: 'right' }}>Amount</th>
                                        <th style={{ textAlign: 'right' }}>Balance</th>
                                      </tr>
                                    </thead>
                                    <tbody className="custom-divide-y">
                                      {acc.transactions.map((tx, tIndex) => {
                                        const isCredit = String(tx?.type || '').toUpperCase() === 'CREDIT' || String(tx?.amount || '').startsWith('+');
                                        return (
                                          <tr key={tIndex}>
                                            <td style={{ textAlign: 'left' }}>{tx?.date || tx?.transaction_timestamp || "—"}</td>
                                            <td style={{ textAlign: 'left', maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                              {tx?.narration || "—"}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                              <span style={{
                                                padding: '2px 8px',
                                                borderRadius: '6px',
                                                fontSize: '10.5px',
                                                fontWeight: 700,
                                                background: isCredit ? '#dcfce7' : '#fee2e2',
                                                color: isCredit ? '#15803d' : '#b91c1c'
                                              }}>
                                                {tx?.type || (isCredit ? 'CREDIT' : 'DEBIT')}
                                              </span>
                                            </td>
                                            <td style={{ textAlign: 'right', fontWeight: 700, color: isCredit ? '#16a34a' : '#dc2626' }}>
                                              {isCredit ? '+' : '-'}{formatCurrency(Math.abs(parseFloat(tx?.amount || 0)))}
                                            </td>
                                            <td style={{ textAlign: 'right', fontWeight: 600 }}>
                                              {formatCurrency(tx?.balance)}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}

                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })
            )}
          </div>

        </div>

        {/* Modal Footer */}
        <div style={{
          padding: '14px 28px',
          borderTop: '1px solid #f1f5f9',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: '#ffffff'
        }}>
          <div style={{ fontSize: '12px', color: '#64748b' }}>
            {data?.main_txn_id && <span>Main Txn ID: <span style={{ fontWeight: 600, color: '#0f172a' }}>{data.main_txn_id}</span></span>}
            {data?.txn_id && <span style={{ marginLeft: '12px' }}>Txn ID: <span style={{ fontWeight: 600, color: '#0f172a' }}>{data.txn_id}</span></span>}
          </div>
          <button
            className="btn btn-secondary"
            onClick={onClose}
            style={{ padding: '8px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: '600' }}
          >
            Close Summary
          </button>
        </div>
      </div>
    </div>
  );
};



